import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Calendar, ArrowLeft } from 'lucide-react';
import DOMPurify from 'dompurify';
import GlobalBlockByType from '../components/GlobalBlockRenderer';
import api from '../lib/api';

const BlogPostPage = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const loadPost = async () => {
      try {
        setLoading(true);
        setError(false);
        const response = await api.get(
          `/publications/by-slug/${encodeURIComponent(slug)}`
        );
        setPost(response.data);
      } catch (err) {
        console.error('Erreur chargement article :', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    loadPost();
  }, [slug]);

  const formatDate = (date) => {
    if (!date) return '';
    return new Date(date).toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  return (
    <div className="min-h-screen bg-white">
      <GlobalBlockByType type="header" />
      <GlobalBlockByType type="menu" />
      <main className="bg-[#F7F5F2]">
        <div className="max-w-4xl mx-auto px-4 py-12">
        <Link to="/blog" className="inline-flex items-center gap-2 text-primary mb-8">
          <ArrowLeft className="h-4 w-4" />
          Retour au blog
        </Link>

        {loading ? (
          <div className="text-center py-16">Chargement de l'article...</div>
        ) : error || !post ? (
          <div className="text-center py-16">
            <h1 className="text-3xl font-bold mb-4">Article introuvable</h1>
            <p>Cet article n'existe pas ou n'est plus disponible.</p>
          </div>
        ) : (
          <article>
            {post.image && (
              <img
                src={post.image}
                alt={post.title}
                className="w-full max-h-[480px] object-cover rounded-xl mb-8"
              />
            )}

            <div className="flex items-center gap-2 text-sm text-muted-foreground mb-4">
              <Calendar className="h-4 w-4" />
              <time dateTime={post.created_at}>{formatDate(post.created_at)}</time>
            </div>

            <h1 className="text-3xl md:text-4xl font-bold mb-8">
              {post.title}
            </h1>

            <div
              className="prose prose-lg max-w-none whitespace-pre-line text-gray-800
              [&_p]:mb-5 [&_p]:leading-8
              [&_h1]:text-3xl [&_h1]:font-bold [&_h1]:mt-10 [&_h1]:mb-5
              [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:mt-10 [&_h2]:mb-4
              [&_h3]:text-xl [&_h3]:font-semibold [&_h3]:mt-8 [&_h3]:mb-3
              [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-6
              [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:mb-6
              [&_li]:mb-2 [&_li]:leading-7
              [&_br]:block"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(post.content || '')
              }}
            />
          </article>
        )}
        </div>
      </main>
    </div>
  );
};

export default BlogPostPage;
